import { computed, input, signal } from '@angular/core';
import { UiLoadingIndicatorComponent } from '@common/ui/frontend-shared/loading-indicator';
import { InnerHtmlClickHandlerDirective, NgLetDirective, SafeHtmlPipe } from '@core/frontend-shared/utils';
import { CmsModulesService } from '../services/cms-modules.service';
import { take } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "../services/cms-modules.service";
const _c0 = () => ({});
function CmsModulePositionComponent_Conditional_1_ng_template_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1, "Keine Inhalte f\u00FCr diese Modulposition gefunden.");
    i0.ɵɵelementEnd();
  }
}
function CmsModulePositionComponent_Conditional_1_ng_template_0_Conditional_1_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 2);
    i0.ɵɵpipe(1, "safeHtml");
  }
  if (rf & 2) {
    const mod_r1 = ctx.$implicit;
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 2, mod_r1.content), i0.ɵɵsanitizeHtml)("innerHtmlClickHandler", i0.ɵɵpureFunction0(4, _c0));
  }
}
function CmsModulePositionComponent_Conditional_1_ng_template_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, CmsModulePositionComponent_Conditional_1_ng_template_0_Conditional_1_For_1_Template, 2, 5, "div", 2, i0.ɵɵrepeaterTrackByIndex);
  }
  if (rf & 2) {
    const parsedMods_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵrepeater(parsedMods_r2);
  }
}
function CmsModulePositionComponent_Conditional_1_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, CmsModulePositionComponent_Conditional_1_ng_template_0_Conditional_0_Template, 2, 0, "p");
    i0.ɵɵconditionalCreate(1, CmsModulePositionComponent_Conditional_1_ng_template_0_Conditional_1_Template, 2, 0);
  }
  if (rf & 2) {
    const parsedMods_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(!parsedMods_r2.length && !ctx_r2.hideIfEmpty() ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(parsedMods_r2.length ? 1 : -1);
  }
}
function CmsModulePositionComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CmsModulePositionComponent_Conditional_1_ng_template_0_Template, 2, 2, "ng-template", 1);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngLet", ctx_r2.parsedModules());
  }
}
export let CmsModulePositionComponent = /*#__PURE__*/(() => {
  class CmsModulePositionComponent {
    constructor(moduleService) {
      this.moduleService = moduleService;
      this.isModPos = true;
      this.hideIfEmpty = input(false, ...(ngDevMode ? [{
        debugName: "hideIfEmpty"
      }] : /* istanbul ignore next */[]));
      this.position = input.required(...(ngDevMode ? [{
        debugName: "position"
      }] : /* istanbul ignore next */[]));
      this.context = input(null, ...(ngDevMode ? [{
        debugName: "context"
      }] : /* istanbul ignore next */[]));
      this.loading = signal(true, ...(ngDevMode ? [{
        debugName: "loading"
      }] : /* istanbul ignore next */[]));
      this.modules = signal([], ...(ngDevMode ? [{
        debugName: "modules"
      }] : /* istanbul ignore next */[]));
      this.parsedModules = computed(() => {
        const moduleList = this.modules();
        const context = this.context();
        return moduleList.map(moduleItem => {
          const parsedContent = context ? moduleItem.content.replace(/{{([a-zA-Z0-9]+?)}}/gm, match => {
            const varname = match.substring(2, match.length - 2);
            return context[varname] || '?' + varname + '?';
          }) : moduleItem.content;
          return {
            ...moduleItem,
            content: parsedContent
          };
        });
      }, ...(ngDevMode ? [{
        debugName: "parsedModules"
      }] : /* istanbul ignore next */[]));
    }
    ngOnInit() {
      this.loading.set(true);
      this.moduleService.getModulesForPosition(this.position()).pipe(take(1)).subscribe({
        next: modules => {
          if (!Array.isArray(modules)) throw new Error('getModulesForPosition returned invalid data: ' + JSON.stringify(modules));
          this.modules.set(modules);
          this.loading.set(false);
        },
        error: err => {
          this.loading.set(false);
          console.error(err);
        }
      });
    }
    static {
      this.ɵfac = function CmsModulePositionComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CmsModulePositionComponent)(i0.ɵɵdirectiveInject(i1.CmsModulesService));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: CmsModulePositionComponent,
        selectors: [["cms-module-position"]],
        hostVars: 2,
        hostBindings: function CmsModulePositionComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("cms-module-position", ctx.isModPos);
          }
        },
        inputs: {
          hideIfEmpty: [1, "hideIfEmpty"],
          position: [1, "position"],
          context: [1, "context"]
        },
        decls: 2,
        vars: 2,
        consts: [[3, "loading"], [3, "ngLet"], [1, "module", 3, "innerHTML", "innerHtmlClickHandler"]],
        template: function CmsModulePositionComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "ui-loading-indicator", 0);
            i0.ɵɵconditionalCreate(1, CmsModulePositionComponent_Conditional_1_Template, 1, 1, null, 1);
          }
          if (rf & 2) {
            i0.ɵɵproperty("loading", ctx.loading());
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.loading() ? 1 : -1);
          }
        },
        dependencies: [UiLoadingIndicatorComponent, NgLetDirective, InnerHtmlClickHandlerDirective, SafeHtmlPipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return CmsModulePositionComponent;
})();